import { TextField } from "@material-ui/core";
import { observer } from "mobx-react";
import React from "react";
import Formatter, { CapitalizationType } from "../../../helpers/formatter";
import { GravestoneProposalModel } from "../../../helpers/gravestoneProposalModel";
import Notification from "../../sharedComponents/notification/notification";

interface PlotProps {
  gravestone: GravestoneProposalModel;
}

@observer
export default class Plot extends React.Component<PlotProps> {

  public render() {
    return (
      <div className="field-container">
        <div className="label">Grób</div>
        <TextField
          value={this.props.gravestone.plot}
          variant="outlined"
          size="small"
          helperText={<Notification type="info" message="Opcjonalne" />}
          label="Grób"
          InputLabelProps={{
            shrink: true
          }}
          onChange={(event) => {
            this.props.gravestone.plot = Formatter.capitalizeWords(event.target.value, CapitalizationType.full);
          }}
          onBlur={(event) => {
            this.props.gravestone.plot = this.props.gravestone.plot?.trim();
          }}
          className="text-input"
        />
      </div>
    );
  }
}
